import MainNotificationRules from '@components/App/NotificationContainer/MainNotificationRules'
import { FetchProject } from '@components/AppMain/FetchProject'
import ArtBoard from '@components/ArtBoard/ArtBoard'
import { NoSitemap } from '@components/NoSitemap'
import { useRedirectAfterAuth } from '@components/Router/hooks/useRedirectAfterAuth'
import type { AppState } from '@store/types'
import type React from 'react'
import { useSelector } from 'react-redux'

import { useProjectSocketsInit } from '@/hooks'

export const Main: React.FC = () => {
  useRedirectAfterAuth()
  useProjectSocketsInit()

  // The fetch stops before the canvas when the project turns out to be a
  // report, so FetchProject still runs — only what it renders into changes.
  const report = useSelector<AppState, boolean>(
    (state) => state.manager.meta.space.type === 'report'
  )

  return (
    <>
      <FetchProject />
      <MainNotificationRules />
      {report ? <NoSitemap /> : <ArtBoard />}
    </>
  )
}
